import { css, FlattenSimpleInterpolation } from 'styled-components';

import { IEdgeStyleData } from '../calcEdgeStyles';

export const calcEdgeStyleMediaShortHand = (query: IEdgeStyleData, kind: string ) => {
  const {
    bottom,
    horizontal,
    left,
    right,
    top,
    vertical,
  } = query;
  const styles: FlattenSimpleInterpolation[] = [];

  if (vertical) {
    styles.push(css`
      ${kind}-top: ${vertical};
      ${kind}-bottom: ${vertical};
    `);
  }

  if (horizontal) {
    styles.push(css`
      ${kind}-left: ${horizontal};
      ${kind}-right: ${horizontal};
    `);
  }

  if (left) {
    styles.push(css`
      ${kind}-left: ${left};
    `);
  }

  if (bottom) {
    styles.push(css`
      ${kind}-bottom: ${bottom};
    `);
  }

  if (right) {
    styles.push(css`
      ${kind}-right: ${right};
    `);
  }

  if (top) {
    styles.push(css`
      ${kind}-top: ${top};
    `);
  }

  return styles;
};
